import { Grid, Column } from '@carbon/react'
import {
  Book,
  IbmDevopsTest,
  Analytics,
  UserMultiple,
} from '@carbon/icons-react'
import { formatAnalyticsPercentOneDecimal } from '@sphere/shared/util'
import { MetricCard } from '../shared'
import styles from './PersonalAnalytics.module.scss'

export interface PersonalMetricsCardsProps {
  totalActivities: number
  totalAttempts: number
  averageScore: number | null
  completionRate: number
}

export function PersonalMetricsCards({
  totalActivities,
  totalAttempts,
  averageScore,
  completionRate,
}: PersonalMetricsCardsProps) {
  return (
    <Grid narrow className={styles.metricsGrid}>
      <Column lg={4} md={4} sm={4}>
        <MetricCard
          title="Total des Activités"
          value={totalActivities}
          subtitle="Activités utilisées"
          icon={Book}
        />
      </Column>
      <Column lg={4} md={4} sm={4}>
        <MetricCard
          title="Total des Tentatives"
          value={totalAttempts}
          subtitle="Tentatives d'activités"
          icon={IbmDevopsTest}
        />
      </Column>
      <Column lg={4} md={4} sm={4}>
        <MetricCard
          title="Score Moyen"
          value={formatAnalyticsPercentOneDecimal(averageScore)}
          subtitle="Performance moyenne"
          icon={Analytics}
        />
      </Column>
      <Column lg={4} md={4} sm={4}>
        <MetricCard
          title="Taux de Réussite"
          value={formatAnalyticsPercentOneDecimal(completionRate)}
          icon={UserMultiple}
          progress={completionRate}
        />
      </Column>
    </Grid>
  )
}
